import { HeartbeatEngine } from './v2/heartbeat.engine';

export { getSessionInitialProps } from './v2/heartbeat.utils';

export const Heartbeat = new HeartbeatEngine();
